module.exports = __webpack_public_path__ + "img/about-teachers.4614b01a.svg";